import Cookies from "js-cookie";
import {
  GET_EVAL_PROMPTS_URL,
  GET_EVAL_PROMPT_URL,
  UPDATE_EVAL_PROMPT_URL,
  CREATE_EVAL_PROMPT_URL,
  DELETE_EVAL_PROMPT_URL,
} from "../apiurls/apiurls";

const getAuthToken = () => {
  return Cookies.get("admin_token");
};

const getHeaders = () => {
  const headers = { "Content-Type": "application/json" };
  const token = getAuthToken();
  if (token) {
    headers["Authorization"] = ` ${token}`;
  }
  return headers;
};

export const getEvalPrompts = async (type) => {
  const params = new URLSearchParams();
  const validTypes = ['content_eval', 'ai_tutor_eval', 'personalized_quiz_eval', 'quiz_eval',"adaptive_learning_eval",
    "personalized_content_eval",
    "test_result_feedback_eval",];
  if (type && validTypes.includes(type)) {
    params.append("types", type);
  }

  const response = await fetch(`${GET_EVAL_PROMPTS_URL}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  if (data && Array.isArray(data.data)) return data.data;
  return Array.isArray(data) ? data : data ? [data] : [];
};

export const getEvalPromptById = async (id) => {
  if (!id) {
    throw new Error("EvalPrompt id is required");
  }

  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${GET_EVAL_PROMPT_URL}?${params.toString()}`, {
    method: "GET",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};

export const updateEvalPrompt = async (id, payload) => {
  if (!id) {
    throw new Error("EvalPrompt id is required for update");
  }

  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${UPDATE_EVAL_PROMPT_URL}?${params.toString()}`, {
    method: "PUT",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const createEvalPrompt = async (payload) => {
  const response = await fetch(CREATE_EVAL_PROMPT_URL, {
    method: "POST",
    headers: getHeaders(),
    body: JSON.stringify(payload),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};

export const deleteEvalPrompt = async (id) => {
  if (!id) {
    throw new Error("EvalPrompt id is required for delete");
  }

  const params = new URLSearchParams();
  params.append("id", id);

  const response = await fetch(`${DELETE_EVAL_PROMPT_URL}?${params.toString()}`, {
    method: "DELETE",
    headers: getHeaders(),
  });

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json();
};
